<script lang="ts">
  import type { VesselKind } from "../../shared/contracts";
  import { vesselKindLabel } from "../format";
  import DrawerShell from "./DrawerShell.svelte";
  import UnknownVesselBadge from "./UnknownVesselBadge.svelte";

  export let onclose: () => void;
  export let returnFocus: HTMLElement | null;

  const vesselTypes: ReadonlyArray<{ kind: VesselKind; description: string }> = [
    { kind: "tug", description: "A working vessel built to push, pull, or assist other vessels." },
    { kind: "tow", description: "A towing vessel or a vessel reported as part of a tow." },
    { kind: "cargo", description: "A vessel reporting a freight or cargo class." },
    { kind: "tanker", description: "A vessel reporting a liquid-cargo class." },
    { kind: "passenger", description: "A ferry, tour boat, or other passenger vessel." },
    { kind: "pilot", description: "A pilot boat serving vessels entering or leaving port." },
    { kind: "fishing", description: "A vessel reporting a fishing class." },
    { kind: "sailboat", description: "A vessel reporting a sailing class." },
    { kind: "yacht", description: "A vessel reporting a pleasure-craft class." },
    {
      kind: "generic",
      description: "A position is broadcasting, but the vessel has not reported a recognizable class. It could be any boat type.",
    },
  ];
</script>

<DrawerShell
  title="Vessel legend"
  context="What each live silhouette means"
  {onclose}
  {returnFocus}
>
  <p class="drawer-intro vessel-legend__intro">
    Types come from AIS broadcasts. They describe the class a vessel reports, not its intent or risk.
  </p>

  <ul class="vessel-legend">
    {#each vesselTypes as vesselType (vesselType.kind)}
      <li class:vessel-legend__item--unknown={vesselType.kind === "generic"} class="vessel-legend__item">
        <span class="vessel-legend__art" aria-hidden="true">
          <img src={`/assets/vessels/${vesselType.kind}-compact.webp`} alt="" decoding="async" />
          {#if vesselType.kind === "generic"}<UnknownVesselBadge />{/if}
        </span>
        <span class="vessel-legend__copy">
          <strong>{vesselKindLabel(vesselType.kind)}</strong>
          <span>{vesselType.description}</span>
        </span>
      </li>
    {/each}
  </ul>
</DrawerShell>
